import { ApiBase } from '@/api/api'
import { makePatchRequest } from '@/api/fetchCalls'
import { TeamConfigModel } from '@/domain/model/team'

type RecordTree = {
  [key: string]: string | number | boolean | RecordTree
}

export type UpdateTeamConfigProps = {
  data: Partial<RecordTree> & {
    teamId: number
  }
}
export const updateTeamConfig = async ({
  data: { teamId, ...rest },
}: UpdateTeamConfigProps): Promise<TeamConfigModel> => {
  return makePatchRequest(ApiBase + `/teams/${teamId}`, {
    body: JSON.stringify(rest),
  })
}
